import React from 'react';
import { ImageHeader } from '../components/ImageHeader';
import { useGuest } from '../contexts/GuestContext';

import travelImageUrl from 'url:../assets/travel-accommodation-banner.jpg';

const TravelAccommodation = () => {
  const { guestType } = useGuest();
  const imageUrl = travelImageUrl;
  const headerContent = (<h1>Travel & Accommodation</h1>);

  return (
    <>
      <ImageHeader imageUrl={imageUrl} headerContent={headerContent} />
      <article className="block-content block-content-longtext">
        <h2>Getting Here</h2>
        <p>Stroud is easily accessible by rail, with a central train station offering frequent, direct services to London Paddington.</p>
        <p>It's also a lovely drive through the rolling hills, and many of the accommodations we've found have ample parking.</p>
        <p>Our venue, <em>Copsegrove Farm</em>, is just a 15 minute drive from Stroud station.</p>

        <h3>Directions to the Venue</h3>
        <p>The venue is by car only (unless you fancy a country walk in your gladrags!).</p>
        <p>If you're using Satnav, use <strong>"Back Lane, Bisley, Stroud GL6 7BG"</strong> to make sure you're heading to the right place. It's at the end of a very, very long lane, so don't panic!</p>
        <p>Alternatively, you can use the <strong>whatthreewords</strong> location: <a href="https://what3words.com/copiers.informs.increment" target="_blank" rel="noopener noreferrer">///copiers.informs.increment</a></p>

        <h3>Parking</h3>
        <p>There's a whole field of parking available to you! The field is on the right hand side and clearly marked as you approach the venue. Cars can be left overnight and collected on Sunday morning.</p>
      </article>
      <article className="block-content block-content-longtext">
        {guestType === 'farmhouse' ? (
          <>
            <h2>Your Accommodation</h2>
            <p>You're staying with us at the venue!</p>
            <p>We're excited to have you as our special guests at Copsegrove Farm.</p>
          </>
        ) : (
          <>
            <h2>Where to Stay</h2>
            <p>The venue is situated between Stroud, Bisley and Circencester, and there are so many great hotels and B&amp;Bs nearby. Here are some favourites suggested by the venue:</p>
            <ul>
              <li><strong>The Painswick</strong></li>
              <li><strong>Calcot and Spa</strong></li>
              <li><strong>Burleigh Court Hotel</strong></li>
              <li><strong>The Crown - Frampton Mansell</strong></li>
              <li><strong>The Royal George - Birdlip</strong></li>
              <li><strong>The Bell Sapperton</strong></li>
              <li><strong>The Bear - Bisley</strong></li>
              <li><strong><a href="https://thestroudhotel.com/" target='_blank' rel="noopener noreferrer">The Stroud Hotel</a></strong></li>
              <li><strong><a href="https://www.premierinn.com/gb/en/hotels/england/gloucestershire/stroud/stroud.html" target='_blank' rel="noopener noreferrer">The Premier Inn</a></strong></li>
            </ul>
            <p>
              <strong>Please note:</strong> We recommend booking your stay as early as possible to ensure availability and the best rates.
            </p>
          </>
        )}
      </article>
      <article className="block-content block-content-longtext">
        <h2>Taxi Services</h2>
        <p>We strongly recommend pre-booking a taxi back from the venue. Our venue have recommended:</p>
        <ul>
          <li><strong><a href="https://www.prestigestroudprivatehire.com/" target="_blank" rel="noopener noreferrer">Prestige Stroud Taxi</a></strong></li>
          <li><strong><a href="https://www.wonkyswheels.co.uk/" target="_blank" rel="noopener noreferrer">Wonky's Wheels</a></strong></li>
        </ul>
        <p>If you would like us to help you buddy up with people staying near you to share a cab, please let us know where you're staying and we'll put you in touch.</p>
      </article>
    </>
  );
};

export default TravelAccommodation;
